import PolygonBase from './PolygonBase';
import shapeTriangle from '../assets/icons/shapeTriangle.svg';
import { svgToIcon } from '../utils/svg';

class ShapeTriangle extends PolygonBase {
  calcTextMargin() {
    const { height, width } = this.fabricObject;

    const verticalBound = height / 2;
    const horizontalBound = width / 4;

    return {
      top: verticalBound,
      left: horizontalBound,
      right: horizontalBound,
      bottom: 0,
    };
  }

  static renderIcon() {
    return svgToIcon(shapeTriangle);
  }

  static pathString() {
    return `
      M 0 -0.5
      L 0.5 0.5
      L -0.5 0.5
      Z
    `;
  }

  static shapeControls = this.createDefaultControls();

  static connectControlDefinition() {
    const controls = { ...super.connectControlDefinition() };
    controls.cl = { ...controls.cl!, x: -0.25 };
    controls.cr = { ...controls.cr!, x: 0.25 };
    controls.aux1 = {
      x: -0.5,
      y: 0.5,
      normal: { x: -1, y: 1 },
    };
    controls.aux2 = {
      x: 0.5,
      y: 0.5,
      normal: { x: 1, y: 1 },
    };

    return controls;
  }
}

export default ShapeTriangle;
